import { ComponentProps } from 'react';
import { ControlledSingleUserFieldEditorPopover } from './controlled-single-user-field-editor-popover';
import { withFocusableSelect } from '../components/with-focusable-select';

export const SingleUserFieldEditorPopover = withFocusableSelect<
  number | null,
  ComponentProps<typeof ControlledSingleUserFieldEditorPopover>
>(ControlledSingleUserFieldEditorPopover);
